import { action } from 'typesafe-actions';
import { AuthActionTypes } from './types';
import { IUser } from '../../types';
import { ISessionContext } from 'shared-components/authentication';

export const login = (userName: string, password: string) =>
  action(AuthActionTypes.COGNITO_LOGIN_REQUEST, { userName, password });
export const reauth = () => action(AuthActionTypes.COGNITO_REAUTH_REQUEST);
export const authSuccess = (sessionContext: Omit<ISessionContext, 'getIdToken' | 'onLogout'>) =>
  action(AuthActionTypes.COGNITO_LOGIN_SUCCESS, { sessionContext });
export const testReAuthSuccess = () => action(AuthActionTypes.TEST_LOGIN_SUCCESS);
export const authFailure = (message: string) => action(AuthActionTypes.COGNITO_LOGIN_FAILURE, message);
export const reauthFailure = (message: string) => action(AuthActionTypes.COGNITO_REAUTH_FAILURE, message);
export const logout = (redirect = true) => action(AuthActionTypes.LOGOUT_REQUEST, redirect);
export const logoutSuccess = () => action(AuthActionTypes.COGNITO_LOGOUT_SUCCESS);
export const testing = () => action(AuthActionTypes.TESTING);
export const setUsersUni = (value: string) => action(AuthActionTypes.SET_USERS_UNI, value);
export const setUsersIntake = (value: string) => action(AuthActionTypes.SET_USERS_INTAKE, value);

export const acceptTerms = () => action(AuthActionTypes.ACCEPT_TERMS);
export const acceptTermsSuccess = () => action(AuthActionTypes.ACCEPT_TERMS_SUCCESS);
export const acceptTermsFailure = (message: string) => action(AuthActionTypes.ACCEPT_TERMS_FAILURE, message);

export const getCurrentUserRequest = () => action(AuthActionTypes.GET_CURRENT_USER_REQUEST);
export const getCurrentUserSuccess = (payload: IUser) => action(AuthActionTypes.GET_CURRENT_USER_SUCCESS, payload);
export const getCurrentUserFailure = (message: string) => action(AuthActionTypes.GET_CURRENT_USER_FAILURE, message);

export const getAuthAgencyRequest = (agencyId: string, checkApplyAccess?: boolean) =>
  action(AuthActionTypes.GET_AUTH_AGENCY_REQUEST, { agencyId, checkApplyAccess });
export const getAuthAgencySuccess = (payload: any) => action(AuthActionTypes.GET_AUTH_AGENCY_SUCCESS, payload);
export const getAuthAgencyFailure = (message: string) => action(AuthActionTypes.GET_AUTH_AGENCY_FAILURE, message);
